import CustomMenu from './../../menu/index'
import PropTypes from 'prop-types'
import { MdMoreHoriz } from 'react-icons/md'
import { useLanguageContext } from './../../../context/locale.context'
import { useMemo, useCallback } from 'react'
import { useAuthContext } from './../../../context/auth.context'

const ParticipantMenu = ({
	participantData,
	activityAccess,
	mutateParticipants,
}) => {
	const {
		isOwner,
		isCreator,
		arpLeadSettingEnabled,
		canHaveRemoveAccess,
		isLoggedInUserCreator,
	} = activityAccess

	const {
		state: {
			authData: { asset_id: loggedInuserId },
		},
	} = useAuthContext()

	const {
		state: { locale },
	} = useLanguageContext()

	const canHaveOwnerAccess = useCallback(() => {
		return participantData?.list.some(
			i => i.asset_flag_is_owner === 1 && i.asset_id === loggedInuserId
		)
	}, [participantData, loggedInuserId])

	const optionList = useMemo(() => {
		const list = []
		if (!isOwner) {
			list.push({
				label: locale['Set Owner'],
				isMenu: true,
				optionListProps: { color: 'brand.700' },
				disabled: !canHaveOwnerAccess(),
				onClick: e => {
					mutateParticipants.setOwner()
				},
			})
		} else if (!isCreator) {
			list.push({
				label: locale['Remove Owner'],
				isMenu: true,
				optionListProps: { color: 'brand.700' },
				disabled: !canHaveOwnerAccess(),
				onClick: e => {
					mutateParticipants.removeOwner()
				},
			})
		}
		if (arpLeadSettingEnabled) {
			list.push({
				label: locale['Set Lead'],
				isMenu: true,
				optionListProps: { color: 'brand.700' },
				disabled: !isLoggedInUserCreator,
				onClick: e => {
					mutateParticipants.setLead()
				},
			})
		}
		if (!isCreator && !isOwner) {
			list.push({
				label: locale['Remove participant'],
				isMenu: true,
				optionListProps: { color: 'brand.700' },
				disabled: !canHaveRemoveAccess,
				onClick: e => {
					mutateParticipants.removeParticipant()
				},
			})
		}
		return list
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		arpLeadSettingEnabled,
		canHaveOwnerAccess,
		isLoggedInUserCreator,
		canHaveRemoveAccess,
		isCreator,
		isOwner,
		locale,
	])

	return (
		<>
			{optionList.length > 0 && (
				<CustomMenu
					className={`timeline-attachment-message-menu`}
					icon={MdMoreHoriz}
					color='brand.700'
					boxShadow='none'
					textAlign='center'
					marginLeft='auto'
					_focus={{
						bg: 'white',
					}}
					_hover={{
						bg: 'white',
					}}
					_active={{ bg: 'white' }}
					optionList={optionList}
				/>
			)}
		</>
	)
}

ParticipantMenu.propTypes = {
	participantData: PropTypes.object,
	activityAccess: PropTypes.object.isRequired,
	mutateParticipants: PropTypes.object.isRequired,
}

export { ParticipantMenu }
